module.exports = __webpack_public_path__ + "img/offer5.636bb5d3.jpg";